import type { ComponentType } from 'react';
import type { FallbackProps } from 'react-error-boundary';
import type { ErrorSeverity } from '@gonfalon/telemetry/types';

import type { ErrorBoundaryProps } from './ErrorBoundary';
import { ErrorBoundary } from './ErrorBoundary';
import { GenericError } from './GenericError';

type NoisyErrorBoundaryProps = Pick<ErrorBoundaryProps, 'children' | 'owner'> & {
  severity?: ErrorSeverity;
  FallbackComponent?: ComponentType<FallbackProps>;
};

// `NoisyErrorBoundary` returns a prominent error message as a fallback. Useful as a wrapper for critical content.
// By default, this will be recorded as a "high" severity error in observability tools
export const NoisyErrorBoundary = ({
  FallbackComponent = GenericError,
  children,
  severity = 'high',
  owner,
}: NoisyErrorBoundaryProps) => (
  <ErrorBoundary FallbackComponent={FallbackComponent} severity={severity} owner={owner}>
    {children}
  </ErrorBoundary>
);
